


































































































































/* eslint-disable */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Acomodacoes from '@finx/web-repository/src/constants/Acomodacoes'
import Graus from '@finx/web-repository/src/constants/Graus'
import ProcedimentosWithAcomodacao from '@finx/web-repository/src/constants/ProcedimentosConsultaAcomodacao'
import QuantidadeProcedimentos from '@finx/web-repository/src/constants/QuantidadeProcedimentos'
import TipoAtendimentos from '@finx/web-repository/src/constants/TipoAtendimento'
import Vias from '@finx/web-repository/src/constants/ViasAcesso'
import { Factories } from '@finx/web-repository'

@Component

export default class ComponentProducaoProcedimento extends Vue {
  @Prop(Boolean) isEdit
  // @ts-ignore
  @Prop({ default: 0 }) index: number
  @Prop(Object) procedimento
  @Prop(Object) producao

  acomodacoes: Array<any> = []
  graus: Array<any> = []
  quantidadeProcedimentos: Array<any> = []
  tipoAtendimentos: Array<any> = []
  vias: Array<any> = []
  descricao: String = ''
  showAcomodacao: Boolean = false
  Messages = Factories.Messages
  Validator = Factories.Validator

  mounted() {
    this.getAcomodacoes()
    this.getGraus()
    this.getQuantidadeProcedimentos()
    this.getProcedimentoSequence()
    this.getTipoAtendimentos()
    this.getVias()

    if (this.isEdit) {
      this.getProcedimentoDescription()
    }
  }

  calculateValorProcedimento() {
    let calculateValidation = false
    this.procedimento.isValid = false

    if (this.producao.procedimentoInvasivo) {
      calculateValidation = this.procedimento.descrProcedimento && this.procedimento.quantidade && this.procedimento.grau !== null && this.procedimento.urgente !== null
    } else if (this.showAcomodacao) {
      calculateValidation = this.procedimento.descrProcedimento && this.procedimento.quantidade && this.procedimento.acomodacao
    } else {
      calculateValidation = this.procedimento.descrProcedimento && this.procedimento.quantidade
    }

    if (calculateValidation) {
      this.$emit('calculateValorProcedimento', this.procedimento, this.index)
      this.procedimento.isValid = true
    }
  }

  checkIndexToSetQuantidade() {
    if (this.index === 0) {
      this.procedimento.quantidade = 1
    }
  }

  checkProcedimentoToShowAcomodacao() {
    if (this.procedimento.hasOwnProperty('tabelaPrecoProcedimento')) {
      this.showAcomodacao = ProcedimentosWithAcomodacao.includes(this.procedimento.tabelaPrecoProcedimento.codigoUnico)
    }
  }

  clearProcedimentoSelected() {
    this.descricao = ''
    // this.procedimento.descrProcedimento = ''
    // this.procedimento.quantidade = null
    // this.isValid = true

    // if (this.procedimento.tabelaPrecoProcedimento) {
    //   this.procedimento.tabelaPrecoProcedimento.descricao = ''
    //   this.procedimento.tabelaPrecoProcedimento.codigoUnico = ''
    // }

    // this.procedimento.grau = null
    // this.procedimento.quantidade = null
    // this.procedimento.valorTotal = ''
  }

  deleteProcedimento() {
    this.$emit('deleteProcedimento', this.index)
    // @ts-ignore
    this.$refs.form.resetValidation()
    this.descricao = ''
  }

  getAcomodacoes() {
    this.acomodacoes = Acomodacoes
  }

  getGraus() {
    this.graus = Graus
  }

  getProcedimentoDescription() {
    if (this.procedimento.hasOwnProperty('tabelaPrecoProcedimento')) {
      this.procedimento.descrProcedimento = `${this.procedimento.tabelaPrecoProcedimento.codigoUnico} ${this.procedimento.tabelaPrecoProcedimento.descricao}`
      // this.descricao = `${this.procedimento.tabelaPrecoProcedimento.codigoUnico} ${this.procedimento.tabelaPrecoProcedimento.descricao}`
    }
  }

  getProcedimentoSequence() {
    if (this.procedimento.isNew && this.isEdit) {
      this.procedimento.sequencial = 0
    }

    if (this.procedimento.isNew && !this.isEdit) {
      this.procedimento.sequencial = this.index + 1
    }
  }

  getQuantidadeProcedimentos() {
    this.quantidadeProcedimentos = QuantidadeProcedimentos
  }

  getTipoAtendimentos() {
    this.tipoAtendimentos = TipoAtendimentos
  }

  getVias() {
    this.vias = Vias
  }

  pickProcedimento() {
    this.$emit('pickProcedimento', this.index)
  }

  procedimentoChanges() {
    this.checkProcedimentoToShowAcomodacao()
    this.getProcedimentoDescription()
    this.getProcedimentoSequence()
    this.calculateValorProcedimento()
  }

  validateProcedimento() {
    (this.$refs as any).form.validate()
  }

  @Watch('procedimento.grau')
  onProcedimentoGrauChange() {
    this.procedimentoChanges()
  }

  @Watch('procedimento.descrProcedimento')
  onProcedimentoDescrProcedimentoChange() {
    this.procedimentoChanges()
  }

  @Watch('procedimento.quantidade')
  onProcedimentoQuantidadeChange() {
    this.procedimentoChanges()
  }

  @Watch('procedimento.urgente')
  onProcedimentoUrgenteChange() {
    this.procedimentoChanges()
  }

  @Watch('procedimento.viaAcesso')
  onProcedimentoViaAcessoChange() {
    this.procedimentoChanges()
  }

  @Watch('procedimento.acomodacao')
  onProcedimentoAcomodacaoChange() {
    this.procedimentoChanges()
  }

  @Watch('descricao')
  onDescricaoChange() {
    this.procedimentoChanges()
  }

  @Watch('procedimento.showErrors')
  onProcedimentoShowErrors() {
    this.validateProcedimento()
  }

  @Watch('producao.procedimento', { deep: true })
  onProducaoProcedimento() {
    this.getProcedimentoSequence()
  }

  @Watch('procedimento', { deep: true })
  onProcedimentoChange() {
    if (this.procedimento.tabelaPrecoProcedimento) {
      this.descricao = `${this.procedimento.tabelaPrecoProcedimento.codigoUnico} ${this.procedimento.tabelaPrecoProcedimento.descricao}`
    }

    this.checkIndexToSetQuantidade()
  }

  @Watch('producao.acomodacao')
  onProducaoAcomodacaoChange() {
    this.calculateValorProcedimento()
  }

  @Watch('producao.dataRealizacao')
  onProducaoDataRealizacaoChange() {
    this.calculateValorProcedimento()
  }

  @Watch('producao.procedimentoInvasivo')
  onProducaoProcedimentoInvasivoChange() {
    this.clearProcedimentoSelected()
    // @ts-ignore
    this.$refs.form.resetValidation()
  }

}
